import { ReactNode } from "react";
import { tokens } from "shared/components/Spor";
import { FCWC } from "shared/utils/FCWC";
import styled from "styled-components";

const Wrapper = styled.div`
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  min-width: fit-content;
  width: 100%;
  background-color: ${({ theme }) => theme.colorBackgroundMain};
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows:
    [header] min-content [header-end body] minmax(0, 1fr)
    [body-end];
`;

const HeaderWrapper = styled.div`
  grid-row-start: header;
  grid-row-end: header-end;
  border-bottom: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background-color: ${({ theme }) => theme.colorBackgroundMain};
  padding: ${tokens.default.size.spacing[3]};
  position: sticky;
  top: 0;
  z-index: calc(${tokens.default.depth["z-index"].overlay} + 1);
`;

const BodyWrapper = styled.div`
  grid-row-start: body;
  grid-row-end: body-end;
  width: 100%;
  min-height: 0;
  display: flex;
  overflow: scroll;
`;

const BodyContentWrapper = styled.div`
  flex: 1;
  min-height: 0;
  height: fit-content;
  padding: ${tokens.default.size.spacing[3]};
  box-sizing: border-box;
  min-width: 1200px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

type SectionBoxWithStickyHeaderProps = {
  headerContent: ReactNode;
};

export const SectionBoxWithStickyHeader: FCWC<
  SectionBoxWithStickyHeaderProps
> = ({ headerContent, children }) => (
  <Wrapper>
    <HeaderWrapper>{headerContent}</HeaderWrapper>
    <BodyWrapper>
      <BodyContentWrapper>{children}</BodyContentWrapper>
    </BodyWrapper>
  </Wrapper>
);
